<template>
  <div id="app" scroll="no" :style="cssProps"  @mousedown="stopTimeOutTimer" @mouseup="resetTimeOutTimer" @touchstart="stopTimeOutTimer" @touchend="resetTimeOutTimer" >
  <!-- <style>
    :root {
      -theme-color: {{ themeColor[0] }};
      -theme-color2: {{ themeColor[1] }};
      -theme-color3: {{ themeColor[2] }};
      -theme-color4: {{ themeColor[3] }};
    }
  </style> -->
    <!-- <vue-web-cam /> -->
    <!-- <img alt="Vue logo" src="./assets/logo.png" /> -->
<div v-if="!acdnd">
    <Gallery ref="gallery"
               v-if="!is_in_app && isDataLoaded && byst_CompareCurrentStates(['gallery', 'gallery/*'])"
               :plusButtonColors="themeColors"
               @resetTimeOutTimer="resetTimeOutTimer"></Gallery>
    <MessageUI :themeId='1'
               :themedata="theme"
               @resetTimeOutTimer="resetTimeOutTimer"
               v-if="isDataLoaded && !byst_CompareCurrentStates(['gallery', 'gallery/*'])"></MessageUI>
      <!-- <lightbox></lightbox> -->
      <div class="timeout" v-if="isTimeoutWindow" />
   </div>
   <div v-if="acdnd">You are not allowed to run PopBook in desk mode.</div>
</div>
</template>

<script>
import axios from 'axios'
//import HelloWorld from './components/HelloWorld.vue'
//import { WebCam } from 'vue-web-cam'
import { sync } from 'vuex-pathify'
import {UAParser} from "ua-parser-js"
//import store from './components/Lightbox/LightboxStore'
import './components/Lightbox/LightboxDirective';
import Lightbox from './components/Lightbox'
import MessageUI from './components/MessageUI'
import Gallery from './components/Gallery'
import { blueyetiStates } from './utils/blueyetiStates'
import VueTimers from 'vue-timers';
import compareVersions from 'compare-versions';


export default {
  name: 'app',
  components: {
    //HelloWorld,
    //"vue-web-cam": WebCam,
    Lightbox,
    MessageUI,
    Gallery
},
data() {
   return {
      config: {},
      theme: null,
      isDataLoaded: false,
      acdnd: false,
      isTimeoutWindow: false,
      themeColors: ['#00e1eb', '#fdf070', '#bedc86', '#f85ea6'],
   }
},
mixins: [blueyetiStates],
created() {


   let uri = window.location.href.split('?');

//   axios.get(uri[0] + 'static/config.json').then(response => {
 var that = this;
      axios.get('config.json').then(response => {
   console.log(response.data.config);
   //that.config = response.data.config;
   this.desk_camera_name = response.data.config.desk_camera_name;
   that.content = response.data.content;
})

   if (uri.length == 2)
   {
     let vars = uri[1].split('&');
     let getVars = {};
     let tmp = '';
     vars.forEach(function(v){
      tmp = v.split('=');
      if(tmp.length == 2)
      getVars[tmp[0]] = tmp[1];
     });
     console.log(getVars);
     if(getVars.hasOwnProperty('mode')){
        console.log('mode: ' +getVars['mode']);
          this.is_in_app = getVars['mode'] == 'inapp';
     }
  }
//  if (uri[0] === 'http://localhost:8080/') {
if (window.location.port =='8080') {
       this.is_dev_mode = true;
       console.log("DEV MODE " + this.is_dev_mode)
   }
   // get window size
   window.addEventListener('resize', this.handleResize)
   this.handleResize();

   console.log("this.host_prod " + this.host_prod)
   console.log("uri[0]d " + uri[0])

   var parser = new UAParser();
   if (parser.getUA() == 'POPBook-desk')
   {
      //console.log("popbook desk user agent " + parser.getUA());
      this.os = 'Windows';
      this.is_in_app = false;
   }
   else {
      if(!this.is_in_app &&  !this.is_dev_mode) //uri[0].slice(0, -1) == this.host_prod) {
      {
         this.acdnd = true;
      }
      this.os = parser.getOS().name;
      this.os_version = parser.getOS().version;
      console.log("os " + this.os + " version " + this.os_version);
      console.log("browser " + parser.getBrowser().name + " version " + parser.getBrowser().version);
      console.log("engine " + parser.getEngine().name + " version " + parser.getEngine().version);
      console.log("device " + parser.getDevice().model + " type " + parser.getDevice().type + " vendor " + parser.getDevice().vendor);
//compareVersions(this.os_version, '7.0'); //  1
      this.pause_gif_enable = (this.os == "Android" && compareVersions(this.os_version, '7.0') < 1) || (this.os == "iOS" &&  compareVersions(this.os_version, '10.0') < 1);
      console.log("pause_gif_enable " + this.pause_gif_enable);


   }
   //this.is_retina = this.is_in_app && this.os != "Android"

   if (!this.acdnd) {
      if (this.is_in_app)
      {
         this.byst_SetState('shooting/loading');
         this.$timer.stop('refreshTimeOutTimer');
         this.menuScale = 0.5;
      } else {
//         console.log('lastMessageID ' + this.$localStorage.get('lastMessageID'));

         var mess = this.$localStorage.get('lastMessageID');
         if(mess != null) {
            //console.log('lastMessageID ' + this.messageId);
            this.messageId = mess;
            console.log('lastMessageID ' + this.messageId);
            this.$localStorage.remove('lastMessageID')
         }
         else {
            console.log('no lastMessageID ' + mess);
         }

      }

      this.loadSettings();

   }
},
destroyed() {
  window.removeEventListener('resize', this.handleResize)
},
mounted() {
},
timers: {
   timeOutTimer: { time: 55000, autostart: false },
   timeOutTimer2: { time: 10000, autostart: false },
   galleryTimeOutTimer: { time: 5000, autostart: false },
   refreshTimeOutTimer: { time: 20000, autostart: true }
},

computed: {
   //settings: sync('settings'),
   content: sync('content'),
   is_dev_mode: sync('is_dev_mode'),
   isIdle: sync('is_idle'),
   is_gallery_lightbox:sync('is_gallery_lightbox'),
   userAgent: sync('userAgent'),
   os: sync('os'),
   os_version: sync('os_version'),
   is_retina: sync('is_retina'),
   pause_gif_enable: sync('pause_gif_enable'),
   window_width: sync('message_width'),
   window_height: sync('message_height'),
   messageId: sync('messageId'),
   desk_camera_name: sync('desk_camera_name'),
   isPortrait: sync('isPortrait'),
   menuScale: sync('menuScale'),
   is_in_app: sync('is_in_app'),
   api_address:sync('api_address'),
   host_address:sync('host_address'),
   host_dev:sync('host_dev'),
   host_prod:sync('host_prod'),
   token:sync('token'),
   printerEnable: sync('settings@printer'),
   rgpd: sync('settings@rgpd'),
   theme_id: sync('settings@theme_id'), //id thème
   privat_id:  sync('settings@privat_id'),
   form:  sync('settings@form'),
   display_form:  sync('settings@display_form'),
   display_newsletter_checkbox:  sync('settings@display_newsletter_checkbox'),
   display_contest_checkbox:  sync('settings@display_contest_checkbox'),
   timeout:  sync('settings@timeout'),
   timeout2:  sync('settings@timeout2'),
   refresh:  sync('settings@refresh'),
   adminCode:  sync('settings@adminCode'),
   themeMainColor: sync('themeMainColor'),
  cssProps() {
     console.log('--theme-color' + this.themeMainColor);
     return {
      '--theme-color': this.themeMainColor,
      '--menu-scale': this.menuScale
    }
  }
},
methods: {
   handleResize() {
      if (this.is_in_app) {
         this.window_width = window.innerWidth;
         this.window_height = window.innerHeight;
      }
      //window.devicePixelRatio
      console.log("window size in pixels " + this.window_width + " " + this.window_height)
      console.log("devicePixelRatio " + window.devicePixelRatio)
},
   loadSettings: function(){
      const that = this;
      console.log("hostname " + window.location.hostname);
      var hostname = "https://" + window.location.hostname;
      if (hostname != this.host_prod && hostname != this.host_dev){
//         this.host_address = this.host_prod;
         this.host_address = this.host_dev;
      }
      else {
         this.host_address = hostname;
      }
      this.api_address = this.host_address + "/api/"
      console.log("API address " + this.api_address);
      axios.post(this.api_address + 'settings', {
         token: this.token,
         test: 'ok'
       })
   .then(function (response) {
    console.log(response);
    var data = JSON.parse(response.data);
    that.rgpd = data.rgpd;
    that.printerEnable = data.printer;
    that.theme_id = data.theme_id;
    that.privat_id = data.privat_id;
    that.form = data.form;
    that.display_form = data.display_form;
    that.display_newsletter_checkbox = data.display_newsletter_checkbox;
    that.display_contest_checkbox = data.display_contest_checkbox;
    if (data.rgpd != null)
      that.rgpd = data.rgpd;
   that.adminCode = data.adminCode;

// timers
    that.timeout = data.timeout; //that.timeOutTimer.time
    that.timeout2 = data.timeout2; //that.timeOutTimer2.time
    that.refresh = data.refresh;

    that.timers.timeOutTimer.time = that.timeout * 1000;
    that.timers.timeOutTimer2.time = that.timeout2 * 1000;
    that.$timer.stop('refreshTimeOutTimer')
    if (that.refresh > 5) // security to not have the app refresh too much
      that.timers.refreshTimeOutTimer.time = that.refresh * 1000;

      if (!that.is_in_app)
         that.$timer.start('refreshTimeOutTimer')


    that.loadTheme(data.theme_id);
   //this.loadTheme();
   })
   .catch(function (error) {
    console.log(error);
   });

   },
      loadTheme: function(themeId){
      const that = this;
      axios.post(this.api_address + 'theme', {
         token: this.token,
         id: themeId
      })
      .then(function (response) {
         var theme = JSON.parse(response.data);
         that.theme =  {};
         Object.assign(that.theme,theme);
         that.theme.backgrounds = [];
         console.log(theme);
         console.log("theme.backgrounds.length " +  theme.backgrounds.length)
         that.isPortrait = that.window_height > that.window_width;
         console.log("isPortrait " +  that.isPortrait)

          var i = 0;
          for (i = 0 ; i < theme.backgrounds.length  ; i++)
          {
             //console.log("theme.backgrounds[i].filename " +  theme.backgrounds[i].filename)
             if (that.isPortrait) {
                theme.backgrounds[i].filename = theme.backgrounds[i].filename_portrait;
                theme.backgrounds[i].thumbnail = theme.backgrounds[i].thumbnail_portrait;
                console.log(theme.backgrounds[i].filename);
             }
             //console.log(theme.backgrounds[i].type);

             if (theme.backgrounds[i].type == 'selfie' || theme.backgrounds[i].filename.slice(-1) != "/")
               {
                  that.theme.backgrounds.push(theme.backgrounds[i])
               }
               else {
                  console.log("no image background_id " +  theme.backgrounds[i].background_id)
               }
          }

          that.themeColors[0] = that.themeMainColor = that.theme.theme_main_color;
          that.themeColors[1] = that.theme.theme_aux_color1;
          that.themeColors[2] = that.theme.theme_aux_color2;
          that.themeColors[3] = that.theme.theme_aux_color3;
          console.log("that.theme color " + that.themeMainColor);

          that.isDataLoaded = true;


      })
      .catch(function (error) {
         console.log(error);
         that.isDataLoaded = true;
         // that.backgrounds = that.defaultBackgrounds;
         // that.stickers = that.defaultStickers;
         // that.onThemeLoaded();
         // that.setCurrentSlide(0);
      });
   },
   galleryTimeOutTimer: function(){
      this.$timer.stop('timeOutTimer');
      this.$timer.stop('galleryTimeOutTimer');
      if(!this.is_gallery_lightbox) {
         console.log('gallery timeout timer : reset idle');
         this.isIdle = true;
      } else {
         this.$timer.start('timeOutTimer');
      }

   },
   timeOutTimer: function(){
      this.$timer.stop('timeOutTimer')
      console.log('timeout timer : display timeout');
      //location.reload();
      //this.$timer.start('timeOutTimer')
      if(this.isIdle){
         this.resetApp();
      }
      else {
         this.isTimeoutWindow = true;
         this.$timer.start('timeOutTimer2')
      }
      this.isIdle = true;
   },
   timeOutTimer2: function(){
      this.$timer.stop('timeOutTimer2')
      console.log('timeout timer : reload');
      //this.resetApp();
      location.reload();
   },
   stopTimeOutTimer: function(){
      this.$timer.stop('timeOutTimer')
      this.$timer.stop('timeOutTimer2')
      this.$timer.stop('refreshTimeOutTimer')
      console.log('stop timeout timer');
   },
   resetTimeOutTimer: function(){
      var that = this;
      setTimeout(function() { // delay to get is_gallery_lightbox correct value
      that.$timer.stop('timeOutTimer')
      that.$timer.stop('timeOutTimer2')
      that.$timer.stop('refreshTimeOutTimer')
      console.log('reset timeout timer');
      that.isTimeoutWindow = false;
      that.isIdle = false;
      //console.log("timeOutTimer.time " + this.timeOutTimer.time);
      if (!that.is_in_app) {
            console.log('this.is_gallery_lightbox ' + that.is_gallery_lightbox);
            if(that.byst_CompareCurrentStates(['gallery']) && !that.is_gallery_lightbox) {
              that.$timer.start('galleryTimeOutTimer')
           } else {
              that.$timer.start('timeOutTimer')
           }
      }
   },300);
   },
   refreshTimeOutTimer: function(){
      this.$timer.stop('timeOutTimer')
      this.$timer.stop('timeOutTimer2')
      this.$timer.stop('refreshTimeOutTimer')
      console.log('refresh timeout timer');
      this.resetApp();
   },
   resetApp: function(){
      console.log('reset App');
      this.$timer.stop('timeOutTimer')
      this.$timer.stop('timeOutTimer2')
      this.loadSettings();
      if (this.is_in_app)
      {
         this.byst_SetState('shooting/loading');
      }
      else {
   //      this.$timer.stop('refreshTimeOutTimer')
         this.byst_SetState('gallery');
         //this.$refs.gallery.closeLightbox();
         this.$refs.gallery.reset();
         this.$timer.start('refreshTimeOutTimer')
      }
      this.isTimeoutWindow = false;
      this.isIdle = true;

   },

}
}
</script>

<style lang="scss">
@font-face {
  font-family: 'sabon';
  src: url('./assets/sabon-italic-1361498964.ttf');
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: 'Univers Condensed';
  src: url('./assets/Univers-Condensed.otf');
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #444;
//  color: #2c3e50;
  width: 100%;
//  height: 100%;
  height: 100%;
  margin-top: 0px;
  margin-left: 0px;
  overflow: hidden;
  touch-action: none;
  position: fixed;
  overflow: hidden;
  //overflow:auto;
  background: black;
}

img{
    -khtml-user-select: none;
    -o-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}
.timeout{
   position: absolute;
   width: 100%;
 //  height: 100%;
   height: 100%;
   margin-top: 0px;
   margin-left: 0px;
   top:0;
   left:0;
   z-index:7777;
   background-color: rgba(0,0,0,0.5);
}
</style>
